import { render } from "./homePage5.vue?vue&type=template&id=e9277cfa&scoped=true"
import script from "./homePage5.vue?vue&type=script&lang=js"
export * from "./homePage5.vue?vue&type=script&lang=js"

import "./homePage5.vue?vue&type=style&index=0&id=e9277cfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9277cfa"]])

export default __exports__